// for use with arbitrary URLs or document (using doc.location.search then)
export function parseUrlParams2(docOrUrl, lowercaseNames) {
  const url = typeof docOrUrl === 'string' ? docOrUrl : docOrUrl.location.search;
  const parameters = new URLSearchParams(url);
  const paramsMap = {};
  parameters.forEach((value, originalName) => {
    const name = lowercaseNames ? originalName.toLowerCase() : originalName;
    const multi = name.endsWith('[]');
    if (multi) {
      const values = parameters.getAll(originalName);
      paramsMap[name.substring(0, name.length - 2)] = values;
    } else {
      paramsMap[name] = value;
    }
  });
  return paramsMap;
}